import { useMutation } from '@tanstack/react-query'
import { request } from 'Lib/axios'
import { useUserStore } from 'Stores/userStoreModuleFed'
import { queryClient } from 'Lib/react-query'
import { useAppStore } from 'Stores/appStoreModuleFed'
import i18n from 'Lib/i18n'

export type ExtendTrialResponse = {
  endDate: string
  remaining: number
}

const extendTrial = async () => {
  const accountId = useUserStore.getState().accountId

  return await request<{ data: ExtendTrialResponse }>({
    url: `accounts/${accountId}/subscriptions/extend-trial`,
    method: 'POST',
  })
}

export const useExtendTrial = () => {
  const { showToaster } = useAppStore()
  return useMutation(extendTrial, {
    onSuccess: (response) => {
      if (!(response instanceof Error)) {
        showToaster(
          i18n.t('cross-sell.cross_sale_pricing.update_successfully', { ns: 'pricing' }),
          'success'
        )
        void queryClient.invalidateQueries({ queryKey: ['getPackagesLimits'] })
        void queryClient.invalidateQueries({ queryKey: ['accountSettings'] })
        void queryClient.invalidateQueries({ queryKey: ['getPlansDetails'] })
        void queryClient.invalidateQueries({ queryKey: ['accountUsage'] })
        void queryClient.invalidateQueries({ queryKey: ['creditCard'] })
      }
    },
  })
}
